module.exports = __webpack_public_path__ + "static/media/react-logo-primary.5e51d949.svg";